import React from 'react'
import DOMPurify from 'dompurify';
import './components.css'
import "@wordpress/block-library/build-style/common.css";
import "@wordpress/block-library/build-style/style.css";
import "@wordpress/block-library/build-style/theme.css";

const GutenContent = ({ htmldata }) => {

    // console.log(htmldata)
    const cleanHTML = DOMPurify.sanitize(htmldata);

    return (
        <div>
            <div className='html_text_block' dangerouslySetInnerHTML={{ __html: cleanHTML }} />
        </div>
    )
}

export default GutenContent